var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.url)?_c('Img',{staticClass:"l-section__img",class:_vm.classes,attrs:{"data-src":_vm.url,"alt":_vm.title,"width":_vm.width,"height":_vm.height}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }